function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2315 5109 c-800 -83 -1501 -518 -1927 -1196 -604 -960 -491 -2229 272 -3065 423 -463 951 -740 1585 -830 119 -17 512 -16 635 1 623 86 1150 361 1572 821 352 383 572 860 650 1405 17 118 17 512 0 630 -70 490 -251 917 -544 1284 -93 117 -272 296 -393 394 -360 290 -782 474 -1250 543 -123 18 -478 26 -600 13z m562 -1038 c605 -134 1059 -589 1196 -1199 18 -83 21 -128 21 -312 0 -184 -3 -229 -21 -312 -137 -612 -589 -1064 -1201 -1201 -132 -29 -471 -32 -602 -4 -621 130 -1084 586 -1223 1205 -18 83 -21 128 -21 312 0 184 3 229 21 312 144 640 636 1108 1278 1214 120 20 433 12 552 -15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2344 3790 c-86 -66 -188 -208 -254 -354 -34 -77 -35 -82 -16 -89 22 -9 254 -45 329 -52 l67 -6 0 271 0 270 -37 0 c-29 0 -51 -10 -89 -40z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2650 3560 l0 -270 33 0 c81 0 382 45 407 60 9 5 2 30 -23 88 -75 173 -223 359 -304 381 -21 6 -55 11 -75 11 l-38 0 0 -270z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1975 3695 c-78 -41 -171 -102 -238 -158 -57 -48 -55 -51 52 -96 87 -37 98 -38 107 -8 12 38 81 179 118 240 19 31 33 57 31 57 -2 0 -34 -16 -70 -35z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3160 3648 c33 -56 93 -182 105 -217 8 -27 21 -26 97 6 82 34 85 38 62 64 -41 46 -263 199 -288 199 -4 0 7 -24 24 -52z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1501 3273 c-64 -96 -122 -214 -155 -316 -28 -87 -56 -222 -56 -273 l0 -34 228 2 227 3 2 55 c6 138 53 447 78 511 4 10 -14 21 -57 38 -35 13 -93 39 -130 57 -37 19 -72 34 -77 34 -5 0 -32 -35 -60 -77z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3520 3315 c-25 -13 -78 -36 -117 -52 -53 -20 -72 -32 -68 -43 32 -108 75 -395 75 -507 l0 -63 210 0 210 0 0 34 c0 98 -55 295 -120 430 -37 78 -130 226 -140 225 -3 0 -25 -11 -50 -24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1991 3143 c-29 -106 -50 -243 -66 -420 l-7 -73 276 0 276 0 -2 233 -3 232 -100 8 c-89 6 -282 37 -342 53 -19 5 -23 0 -32 -33z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3050 3160 c-75 -17 -135 -25 -347 -46 l-53 -5 0 -230 0 -229 295 0 c162 0 295 3 295 8 0 84 -45 396 -70 485 -12 42 -6 41 -120 17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1293 2401 c9 -91 48 -238 90 -337 33 -79 129 -248 147 -259 4 -3 57 18 117 47 59 29 122 58 140 64 l32 12 -15 62 c-24 105 -45 248 -52 364 l-7 111 -229 3 -229 2 6 -69z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1925 2398 c14 -162 49 -382 64 -406 5 -9 16 -9 42 -2 58 18 249 48 347 56 l92 7 0 208 0 209 -276 0 -276 0 7 -72z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2650 2260 l0 -210 59 0 c75 0 269 -25 378 -49 95 -20 83 -30 107 89 16 81 31 193 41 308 l6 72 -295 0 -296 0 0 -210z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3410 2406 c0 -101 -43 -401 -67 -462 -3 -10 5 -18 27 -26 18 -6 76 -32 130 -58 l97 -48 51 82 c93 148 164 350 178 507 l7 69 -212 0 -211 0 0 -64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2650 1585 l0 -295 38 0 c69 0 109 18 170 79 91 90 179 231 241 388 l20 52 -37 10 c-72 19 -199 40 -277 46 -44 3 -97 8 -117 10 l-38 5 0 -295z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2285 1859 c-84 -12 -217 -39 -231 -47 -9 -5 -3 -30 23 -92 94 -228 261 -430 356 -430 l37 0 0 290 0 290 -62 -1 c-35 -1 -90 -5 -123 -10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1777 1720 c-121 -52 -124 -56 -90 -92 60 -64 244 -188 329 -224 l37 -16 -17 27 c-43 66 -86 145 -115 215 -18 41 -37 87 -44 102 l-12 26 -88 -38z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3265 1692 c-15 -37 -51 -113 -80 -169 -29 -57 -51 -103 -48 -103 15 0 153 89 215 139 92 73 125 108 112 121 -5 5 -46 24 -91 44 l-81 35 -27 -67z"
}));
function SvgRegions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegions);
export default __webpack_public_path__ + "static/media/regions.cd883e6255c43d751c8e779d6770388f.svg";
export { ForwardRef as ReactComponent };